import { produce } from "immer";
import {
  FETCH_WOUND_REPORT,
  FETCH_WOUND_REPORT_SUCCESS,
  FETCH_WOUND_REPORT_FAILURE,
} from "./constants";

export const initialState = {
  report: null,
  loading: false,
  // The wound-projection columns are a held-migration set on some environments;
  // the API answers 409 with an explanation rather than 500ing. That is a
  // *state*, not an error toast — the page renders the reason instead of an
  // empty report that would read as "this home has no wounds".
  unavailableReason: null,
  // An UNEXPLAINED failure (anything but the 409 above). Kept apart from
  // unavailableReason because the two render differently — and both are kept
  // apart from "no wounds in this period", which is a claim about the home
  // that a failed fetch knows nothing about.
  loadError: false,
};

const WoundReportReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_WOUND_REPORT:
        draft.loading = true;
        draft.unavailableReason = null;
        draft.loadError = false;
        break;
      case FETCH_WOUND_REPORT_SUCCESS:
        draft.loading = false;
        draft.report = action.payload ?? null;
        draft.unavailableReason = null;
        draft.loadError = false;
        break;
      case FETCH_WOUND_REPORT_FAILURE:
        draft.loading = false;
        draft.report = null;
        draft.unavailableReason = action.payload ?? null;
        // The saga's contract: a failure WITH a reason is the explained 409
        // state; a failure WITHOUT one is an ordinary failed load.
        draft.loadError = !action.payload;
        break;
      default:
        break;
    }
  });

export default WoundReportReducer;
